import { Badge } from '@amzn/awsui-components-console';
import { ActivePackageStatus } from '@amzn/awsdev-docs-virtual-smiley-conference-typescript-client';

// Badge for an Active Packages row status. CONFLICT (two entities claim the same
// package at different commits in one venue) is an error; ACTIVE is healthy.
export const ActivePackageStatusBadge = (props: {
  status: ActivePackageStatus;
}) => {
  const color = props.status === ActivePackageStatus.CONFLICT ? 'red' : 'green';
  return <Badge color={color}>{props.status}</Badge>;
};
